import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrashCan } from "@fortawesome/pro-solid-svg-icons";

interface SelectedActionsProps {
  count: number;
  onGroupUpdate: () => void;
  onDelete: () => void;
}

const SelectedActions: React.FC<SelectedActionsProps> = ({
  count,
  onGroupUpdate,
  onDelete,
}) => (
  <div className="selectedBtn">
    <div className="selectedMsg">{count} Selected</div>
    <OverlayTrigger
      placement="top"
      delay={{ show: 250, hide: 400 }}
      overlay={<Tooltip id="group-update-tooltip">Group Update</Tooltip>}
    >
      <button
        type="button"
        className="selectedAction"
        aria-label="Group Update"
        onClick={onGroupUpdate}
      >
        <FontAwesomeIcon icon={faPenToSquare} />
      </button>
    </OverlayTrigger>
    <button
      type="button"
      className="selectedAction"
      aria-label="Delete Selected"
      onClick={onDelete}
    >
      <FontAwesomeIcon icon={faTrashCan} />
    </button>
  </div>
);

export default SelectedActions;
